import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import google from 'assets/img/google-play.svg'
import apple from 'assets/img/apple.svg'
import * as mobile from 'utils/mobile'
import QRCode from 'react-qr-code'
import Popup from './Popup'
import React from 'react'

interface NativeAppPopupProps {
  close: basic.BasicFunc
}

const type = process.env.REACT_APP_TYPE
const NativeAppPopup: React.FC<NativeAppPopupProps> = ({ close }) => {
  const { t } = useTranslation('basic')
  return (
    <Popup
      isPopup
      centered
      close={close}>
      <div className='nativeApp__popup'>
        <div className='popup__title'>
          <i className='icon icon--logo' />
          <div>{t('useMoreConveniently')}</div>
        </div>
        <p>{t('downloadAppDescription')}</p>
        <div className='nativeApp__buttons'>
          {mobile.isIos()
            ? <div
              className='nativeApp__button'
              onClick={() => {
                window.open(generateIosLink(), '_self')
              }}>
              <img src={apple} alt='app store' />
              <div className='nativeApp__button__content'>
                <div>{t('downloadOnThe')}</div>
                <div>App Store</div>
              </div>
            </div>
            : mobile.isAndroid()
              ? <div
                className='nativeApp__button'
                onClick={() => {
                  window.open(generateAndroidLink(), '_self')
                }}>
                <img src={google} alt='google play' />
                <div className='nativeApp__button__content'>
                  <div className='--uppercase'>{t('getItOn')}</div>
                  <div>Google Play</div>
                </div>
              </div>
              : <div className='nativeApp__qrs'>
                <div className='nativeApp__qr'>
                  <QRCode
                    level='L'
                    size={192}
                    value={generateIosLink()}
                  />
                  <h2>iOS</h2>
                </div>
                <div className='nativeApp__qr'>
                  <QRCode
                    level='L'
                    size={192}
                    value={generateAndroidLink()}
                  />
                  <h2>Android</h2>
                </div>
              </div>}
          <BackBtn
            text={t('continueInBrowser')}
            action={close}
          />
        </div>
      </div>
    </Popup>
  )
}

const generateAndroidLink = () => {
  switch (type) {
    case 'rze01': return 'https://play.google.com/store/apps/details?id=pl.horio.space_storage'
    case 'mm': return 'https://play.google.com/store/apps/details?id=pl.mstorage.mm_android'
    default: return 'https://play.google.com/store/apps/details?id=pl.horio.boxomaty'
  }
}

const generateIosLink = () => {
  switch (type) {
    case 'rze01': return 'https://apps.apple.com/pl/app/storage-space/id6756007325'
    case 'mm': return 'https://apps.apple.com/pl/app/magazynomaty/id6449752291'
    default: return 'https://apps.apple.com/pl/app/boxomaty/id6775508189'
  }
}

export default NativeAppPopup